"use client";
import ScreenLayout from "@/components/layout/screen-layout";

function SubHeadingSectionWeDevlop() {
  return (
    <ScreenLayout>
      <div
        className="relative flex justify-center items-center text-center"
      >
        <div className="max-w-4xl mx-auto px-2">
          <p className="text-lg sm:text-xl text-gray-600 leading-relaxed">
            We build custom softwares, websites, great mobile apps, and high-performing CRMs that help your business grow — smartly, efficiently, and within budget.
          </p>
        </div>
      </div>
    </ScreenLayout>
  );
}

export default SubHeadingSectionWeDevlop;
